import { DEFAULT_TIMEZONE, SELECTED_TIMEZONE_KEY } from '~/support/constants';

import { SET_SELECTED_TIMEZONE, SET_SIDEBAR_STATUS, SET_STUDIO_RIGHT_PANEL_STATUS } from './mutation-types';

export default {
  getSelectedTimezone({ commit }) {
    const selectedTimezone = localStorage.getItem(SELECTED_TIMEZONE_KEY) || DEFAULT_TIMEZONE;

    commit(SET_SELECTED_TIMEZONE, selectedTimezone);
  },

  setSelectedTimezone({ commit }, timezone) {
    localStorage.setItem(SELECTED_TIMEZONE_KEY, timezone);
    commit(SET_SELECTED_TIMEZONE, timezone);
  },

  setSidebarStatus({ commit }, isOpened) {
    commit(SET_SIDEBAR_STATUS, isOpened);
  },

  toggleStudioRightPanel({ commit }, isOpened) {
    commit(SET_STUDIO_RIGHT_PANEL_STATUS, isOpened);
  },
};
